<template>
  <div>
    <div class="text-center depahead rsu">ยืนยันตัวตน</div>
    <div style="max-width: 500px; margin-left: auto; margin-right: auto">
      <div style="height: 60px; padding-top: 10px">
        <v-img style="margin-left: auto; margin-right: auto" width="80px" src="../../assets/depa.png"></v-img>
      </div>
      <v-container>
        <ValidationObserver ref="observer">
          <div>
            <div class="mb-6" style="font-weight: 600; font-size: 22px">
              ยืนยันตัวตน
            </div>
            <div>
              <ValidationProvider name="รูปโปรไฟล์" :key="'รูปโปรไฟล์'" :rules="{ required: false }" v-slot="{ errors }">
                <upload-profile :errors="errors" v-model="input.profile_pic" :height="120"></upload-profile>
              </ValidationProvider>
            </div>
            <div>
              <div style="color: grey">เลขนิติบุคคล</div>
              <ValidationProvider name="เลขนิติบุคคล" :key="'เลขนิติบุคคล'" rules="required|tax_id_card" v-slot="{ errors }">
                <v-text-field type="tel" :error-messages="errors" v-mask="'#############'" v-model="input.id_card" outlined dense></v-text-field>
              </ValidationProvider>
              <div style="color: grey">ชื่อนิติบุคคล</div>
              <ValidationProvider name="ชื่อนิติบุคคล" :key="'ชื่อนิติบุคคล'" :rules="{ required: true }" v-slot="{ errors }">
                <v-text-field placeholder="บริษัท xxx จำกัด" :error-messages="errors" v-model="input.name" outlined dense></v-text-field>
              </ValidationProvider>
              <div style="color: grey">ชื่อผู้ประสานงาน</div>
              <ValidationProvider name="ชื่อผู้ประสานงาน" :key="'ชื่อผู้ประสานงาน'" :rules="{ required: true }" v-slot="{ errors }">
                <v-text-field :error-messages="errors" outlined dense v-model="input.coordinator_name"></v-text-field>
              </ValidationProvider>
              <div style="color: grey">ชื่อหน่วยงาน</div>
              <ValidationProvider name="ชื่อหน่วยงาน" :key="'ชื่อหน่วยงาน'" :rules="{ required: true }" v-slot="{ errors }">
                <v-text-field v-model="input.institute_name" :error-messages="errors" outlined dense></v-text-field>
              </ValidationProvider>
              <!-- <div v-if="documentList && documentList.length">
                <v-layout justify-space-between>
                  <div style="color: grey">อัปโหลดเอกสาร</div>
                  <span @click="showDoc = true" style="color: blue; cursor: pointer;margin-bottom: 5px;text-decoration: underline;">รายการเอกสารที่ต้องอัปโหลด</span>
                </v-layout>
                <div style="display: flex; flex-direction: row">
                  <div style="width: 100%">
                    <ValidationProvider name="เอกสาร" :key="'เอกสาร'" :rules="{ required: true }" v-slot="{ errors }">
                      <UploadDocument :errors="errors" v-model="input.document"></UploadDocument>
                    </ValidationProvider>
                  </div>
                </div>
                <input style="height: 0px; width: 0px; visibility: hidden" type="file" ref="fileuploadinput" />
              </div> -->
            </div>
          </div>
        </ValidationObserver>
        <div class="flex-all-center mb-4">
          <v-flex xs12>
            <v-btn :loading="loading" @click="saveDraft" class="text-capitalize w-max" block>Save Draft</v-btn>
          </v-flex>
        </div>
        <v-layout row justify-space-between>
          <v-flex class="submitbtn">
            <v-btn :loading="loading" @click="back" class="text-capitalize w-max" block>Back</v-btn>
          </v-flex>
          <v-flex class="submitbtn">
            <v-btn :loading="loading" @click="verify" class="text-capitalize w-max" color="primary"
              block>Confirm</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <!-- <v-dialog v-model="showDoc" scrollable persistent max-width="500px" transition="dialog-transition">
      <v-card>
        <div class="text-right">
          <v-btn @click="showDoc = false" icon><v-icon>close</v-icon> </v-btn>
        </div>
        <div class="pa-5">
          <h5>รายการเอกสารที่ต้องอัปโหลด</h5>
          <div v-for="(item, index) in documentList" :key="`doc-list-${index}`">{{ index + 1 }}. {{ item }}</div>
        </div>
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
import UploadProfile from "../../components/UploadProfile.vue";
import { extend } from "vee-validate";
extend("tax_id_card", (value) => {
  if (value.length == 13) {
    return true;
  }
  return "กรุณากรอกเลขนิติบุคคลให้ถูกต้อง";
});
import Vue from "vue";
// import UploadDocument from "../../components/UploadDocumentProfile.vue";
export default {
  components: {
    UploadProfile,
    // UploadDocument
  },


  data() {
    return {
      // showDoc: false,
      loading: false,
      techtype: ["AgTech", "EdTech", "FinTech", "GovTech", "HealthTech", "TravelTech", "Smart City", "Data Platform", "ServiceTech"],
      rounds: ["Preseed", "Seed Fund", "Series A", "Series B", "Series C"],
      input: {
        // document: "",
        tech_startup: false,
        crownfunding: "",
        business_type: "",
        id_card: "",
        institute_name: "",
        name: "",
        coordinator_name: "",
        detail: "",
        website: "",
        contactinfo_phone_number: "",
        contactinfo_address: "",
        contactinfo_email: "",
        amount: 0,
        round: "",
        profile_pic: "",
      },
    };
  },
  computed: {
    selectType() {
      return this.$store.state.input;
    },
    // documentList() {
    //   return this.selectType.document ? this.selectType.document.split(",") : [];
    // },
    dataD() {
      return this.$store.state.profiledata;
    },
  },
  mounted() {
    let draft = Vue.localStorage.get("regisDataTax");
    draft = draft ? JSON.parse(draft) : null;
    if (draft) {
      this.input = draft;
    } else if (this.dataD && this.dataD.institute_name) {
      this.input = {
        // document: this.dataD.document ? this.dataD.document : "",
        tech_startup: this.dataD.tech_startup ? this.dataD.tech_startup : false,
        crownfunding: this.dataD.crownfunding ? this.dataD.crownfunding : "",
        business_type: this.dataD.business_type ? this.dataD.business_type : "",
        id_card: this.dataD.id_card ? this.dataD.id_card : "",
        institute_name: this.dataD.institute_name ? this.dataD.institute_name : "",
        name: this.dataD.name ? this.dataD.name : "",
        coordinator_name: this.dataD.coordinator_name ? this.dataD.coordinator_name : "",
        detail: this.dataD.detail ? this.dataD.detail : "",
        website: this.dataD.website ? this.dataD.website : "",
        contactinfo_phone_number: this.dataD.contactinfo_phone_number ? this.dataD.contactinfo_phone_number : "",
        contactinfo_address: this.dataD.contactinfo_address ? this.dataD.contactinfo_address : "",
        contactinfo_email: this.dataD.contactinfo_email ? this.dataD.contactinfo_email : "",
        amount: this.dataD.amount ? this.dataD.amount : 0,
        round: this.dataD.round ? this.dataD.round : "",
        profile_pic: this.dataD.profile_pic ? this.dataD.profile_pic : "",
      };
    }
  },
  methods: {
    back() {
      this.query.view = "Verifyinfo";
    },
    async verify() {
      if (await this.$refs.observer.validate()) {
        this.loading = true;
        var status = await this.$store.dispatch("depamemberinfo_verification", {
          ...this.$store.state.profiledata,
          ...this.input,
          memberid: this.$store.state.memberid,
        });
        if (status == 200) {
          Vue.localStorage.remove("regisDataTax");
          await this.$liff.closeWindow();
        }
        this.loading = false;
      }
    },
    async saveDraft() {
      this.loading = true;
      let body = {
        ...this.input,
      };
      try {
        Vue.localStorage.set("regisDataTax", JSON.stringify(body));
        this.loading = false;
        await this.$swal.fire({
          icon: "success",
          text: "บันทึกสำเร็จ",
        });
      } catch (error) {
        await this.$swal.fire({
          icon: "error",
          text: "บันทึกไม่สำเร็จ",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
